import { ProductUpdate } from '~/libs/infrastructure/schemas/czMaxPrice';
import { parsePackageSize } from '~/Product';
import { ProductValues } from '../components/Table';
import { ReferenceValues } from '../components/ProductParametersPanel';

export interface Values {
	reference: ReferenceValues;
	product: { [id: string]: ProductValues };
}

export interface ProductUpdatesResult {
	hasValidationError: boolean;
	products: ProductUpdate[];
	validatedValues: Values;
}

export function buildProductUpdatesFromValues(values: Values): ProductUpdatesResult {
	const referencePackageSize = parsePackageSize(values.reference.packageSize.value);
	const referenceValues: ReferenceValues = {
		...values.reference,
		packageSize: { ...values.reference.packageSize, isValid: referencePackageSize.isValid },
	};
	const productValues = { ...values.product };

	let hasValidationError = referencePackageSize.isValid === false;
	const products: ProductUpdate[] = [];

	Object.keys(productValues).forEach((productId) => {
		const pv = productValues[productId];
		const { referencePrice, packageSize, packageSizeForSingleUnit } = pv;

		const parsedPackageSize = parsePackageSize(packageSize.value);
		const parsedPackageSizeForSingleUnit = parsePackageSize(packageSizeForSingleUnit.value);

		hasValidationError =
			hasValidationError ||
			!referencePrice.isValid ||
			parsedPackageSize.isValid === false ||
			parsedPackageSizeForSingleUnit.isValid === false;

		productValues[productId] = {
			...pv,
			packageSize: { ...pv.packageSize, isValid: parsedPackageSize.isValid },
			packageSizeForSingleUnit: { ...pv.packageSizeForSingleUnit, isValid: parsedPackageSizeForSingleUnit.isValid },
		};

		products.push(
			new ProductUpdate(
				productId,
				referencePrice.value?.value ?? null,
				parsedPackageSize.value,
				parsedPackageSizeForSingleUnit.value,
				pv.selected
			)
		);
	});

	return { hasValidationError, products, validatedValues: { reference: referenceValues, product: productValues } };
}
